export default __webpack_public_path__ + "static/Scroll-Image---Oil-Tank-Removal-51b4135be86ecad3b3c4623d3e6a4f22.jpg";